import React, { useEffect, useState } from "react";
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const UserChart = () => {
  const [data, setData] = useState([]);

  // Fetch or set your data here (this could come from an API or static data)
  useEffect(() => {
    const fetchedData = [
      { date: '2023-04-01', usersJoined: 30 },
      { date: '2023-04-02', usersJoined: 40 },
      { date: '2023-04-03', usersJoined: 25 },
      { date: '2023-04-04', usersJoined: 50 },
      { date: '2023-04-05', usersJoined: 60 },
      { date: '2023-04-06', usersJoined: 18 },
      { date: '2023-04-07', usersJoined: 24 },
      { date: '2023-04-08', usersJoined: 38 },
      { date: '2023-04-09', usersJoined: 41 },
      { date: '2023-04-10', usersJoined: 12 },
    ];
    setData(fetchedData); // Set the data from an API or static array
  }, []);

  const chartData = {
    labels: data.map((item) => item.date), // x-axis labels (dates)
    datasets: [
      {
        label: 'Users Joined',
        data: data.map((item) => item.usersJoined), // y-axis values (number of users joined)
        backgroundColor: '#0000ce', // Bar color
        borderRadius: 4, // Rounded corners for bars
      },
    ],
  };

  // Chart options
  const options = {
    responsive: true,
    plugins: {
      title: {
        display: false,
        text: 'Users Joined per Day',
      },
      tooltip: {
        callbacks: {
          label: (context) => `${context.raw} users`, // Customize the tooltip to show the number of users
        },
      },
      legend: {
        display: false, // Hide legend since we removed the label
      },
    },
    scales: {
      x: {
        title: {
          display: false,
          text: 'Date',
        },
        ticks: {
          autoSkip: true,
          maxTicksLimit: 10, // Limit the number of ticks on the x-axis to avoid overlap
        },
      },
      y: {
        title: {
          display: true,
          text: 'Number of Users',
        },
        beginAtZero: true, // Start y-axis at zero
      },
    },
  };

  return (
    <>
      <Bar data={chartData} options={options} />
    </>
  );
};

export default UserChart;
